<main>
	<div class="message">
	</div>
	<div class="centered">
		<div class='row-editor editors-holder'>
			<div class="editor-container" [attr.id]="editorContainer">
				<ckeditor #myEditor class="editor-container" [editor]="Editor" [config]="editorConfig"
					[(data)]="editorData" (change)="onChange($event)" (focus)="trackchangesOn()"
					*ngIf="revisionViewerContainer!=''" [disabled]="readonly"></ckeditor>
					<div class="sidebar sidebar-container d-block" id="sidebar-container" #sidebar></div>
			</div>
			<div [attr.id]="revisionViewerContainer">
				<!-- <div id="revision-viewer-container-assessmentDetails"> -->
				<div class="editor-container">
					<div [attr.id]="revisionViewerEditor"></div>
					<div class="sidebar-container" [attr.id]="revisionViewerSidebar"></div>
				</div>
			</div>
		</div>

	</div>
	<div *ngIf="!readonly" class="col-lg-12 pr-0">
		<span class="text-primary pull-right p-3 pr-0"><button type="submit" [disabled]="isSaveDisable || !buttonActive"
			class="btn btn-sm rounded" (click)="UpdateData()">Save</button>
		</span>
	</div>
</main>
